import { Reveal } from "@/components/Reveal";

const SectionHeading = ({ index, eyebrow, title, sub, light = false }) => (
  <div className="mb-12 sm:mb-16">
    <Reveal>
      <p className="eyebrow flex items-center gap-3" data-testid={`section-eyebrow-${index}`}>
        {index && <span className="text-slate-500">{index}</span>}
        <span className="h-px w-8 bg-blue-500/60" aria-hidden="true" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl ${light ? "text-obsidian" : "text-white"}`}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-4 max-w-xl text-base leading-relaxed sm:text-lg ${light ? "text-slate-600" : "text-slate-400"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
